// @ts-nocheck
import { ResponsiveTreeMap } from '@nivo/treemap';
import { getSymbol } from '../../../helpers/functions';
import { gradient, IAllAssetsCombined } from './helpers';
import { ProfitLoss } from '../../ProfitLoss';

const TreemapChart = ({ data }: { data: Required<IAllAssetsCombined>[] }) => {
  return (
    <ResponsiveTreeMap
      data={{
        name: '',
        children: data,
      }}
      animate={false}
      leavesOnly={true}
      innerPadding={1}
      borderWidth={0}
      label={(e) => e.id}
      labelSkipSize={50} // Skip label rendering when text is not fitting
      identity="name"
      // colors={(node) => getColor(node.data)}
      // value={'value'}
      value={'treeMapValue'}
      valueFormat=".02s"
      nodeOpacity={1}
      labelTextColor={'white'}
      // TODO .slice(0, 8) se piu grande di 8 uso tooltip
      tooltip={({ node }) => <Tooltip data={node.data} />}
      orientLabel={false}
      defs={[
        gradient('veryBad', '#B91C1C', '#DC2626'),
        gradient('bad60', '#DC2626', '#EF4444'),
        gradient('bad40', '#EF4444', '#F87171'),
        gradient('bad20', '#F87171', '#FCA5A5'),
        gradient('bad', '#FCA5A5', '#fac9c9'),
        gradient('normal', '#baeccb', '#86EFAC'),
        gradient('good', '#86EFAC', '#4ADE80'),
        gradient('good40', '#4ADE80', '#22C55E'),
        gradient('good60', '#22C55E', '#16A34A'),
        gradient('veryGood', '#16A34A', '#15803D'),
      ]}
      // colore in bae al andamento del asset, % di diferenza tra i 2 valori 7gg fa e oggi
      fill={[
        { match: ({ data }) => data.percentage < -80, id: 'veryBad' },
        { match: ({ data }) => data.percentage < -60, id: 'bad60' },
        { match: ({ data }) => data.percentage < -40, id: 'bad40' },
        { match: ({ data }) => data.percentage < -20, id: 'bad20' },
        { match: ({ data }) => data.percentage < 0, id: 'bad' },
        { match: ({ data }) => data.percentage > 80, id: 'veryGood' },
        { match: ({ data }) => data.percentage > 60, id: 'good60' },
        { match: ({ data }) => data.percentage > 40, id: 'good40' },
        { match: ({ data }) => data.percentage > 20, id: 'good' },
        { match: ({ data }) => data.percentage > 0, id: 'normal' },
        { match: '*', id: 'normal' },
      ]}
    />
  );
};

function Tooltip({
  data: { currency, tooltipName, percentage, value },
}: {
  currency?: string;
  tooltipName: string;
  percentage: number;
  value: number;
}) {
  return (
    <div
      className={`
        bg-white
        dark:bg-grey-90
        dark:border-grey-80
        rounded-xl
        py-3
        px-5
        border
        border-grey-10
      `}
    >
      <div>{tooltipName}</div>
      <ProfitLoss
        displayType="text"
        value={value}
        symbol={currency ? getSymbol(currency) : undefined}
        percentage={percentage}
        textColor={currency ? undefined : 'black'}
        usePerformance={typeof currency === 'string'}
      />
    </div>
  );
}

export default TreemapChart;
